import { NgModule } from '@angular/core';
import { AdminRoutingModule } from './admin-routing.module';
import { NgxAimQuillModule } from 'ngx-aim';

@NgModule({
  imports: [
    AdminRoutingModule,
    NgxAimQuillModule,
  ]
})
export class AdminModule {}
